<template>
    <div id="latsas-behov-sammanstallning">
        <sammanstallning-field
            :field-value="assistansErsattningEjBehov"
            text-value="impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.latsashabehov.alla.etikett.hurvetduingethjalpbehov"
        ></sammanstallning-field>
    </div>
</template>

<script>
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import SammanstallningField from "@/components/Kontaktuppgifter/SammanstallningField.vue";

export default Vue.extend({
    name: "LatsasBehovSammanstallning",
    components: {
        SammanstallningField,
    },
    computed: {
        ...mapFields(["observationer.assistansErsattning.assistansErsattningEjBehov"]),
    },
});
</script>
